import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { UsageBucketKey } from '~/app/dashboard/v2/components/SiteUsageBreakdown/usageBreakdownUtils'

/**
 * Maps a usage bucket ('human' | 'autonomous' | 'public') to its localized
 * label, shared by the Site Usage Breakdown tile's donut legend and its
 * details overlay. The parameter is the typed union, so the resulting
 * `siteUsageBreakdown_${bucket}` template is itself a literal union of valid
 * keys and TS verifies every branch against the locale file.
 */
export default function useUsageBucketFormatter() {
  const t = useTranslations('dashboard.widgets')
  return useCallback((bucket: UsageBucketKey) => t(`siteUsageBreakdown_${bucket}`), [t])
}
